import React from "react";
import ExclamationIcon from "../../../assets/icons/ABHA-icons/excalmation-icon";
import AddButton from "../../buttons/button";

function Popup({ setStatus, setPosition, setPopup }) {
  const closeModal = () => {
    setStatus("ABHA Address");
    setPosition(3);
    setPopup(false);
  };
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };
  return (
    <div
      onClick={handleOverlayClick}
      className="fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.7)] backdrop-blur-sm z-[2300]"
    >
      <div className="bg-white flex flex-col  gap-6 justify-center items-center w-[448px] h-[324px] rounded-2xl overflow-hidden p-8">
        <div className="flex justify-center items-center w-16 h-16 bg-[var(--error-color)] rounded-full">
          <ExclamationIcon />
        </div>
        <label
          className={`text-[var(--error-color)] 
                 text-[length:var(--abha-method-title2-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
        >
          ABHA Account Exist
        </label>
        <div className="flex flex-col justify-center items-center gap-3">
          <label
            className={`
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] `}
          >
            We have found an ABHA xx-xxxx-xxxx-2650
          </label>
          <label
            className={`
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] `}
          >
            against the Aadhaar number provided by you.
          </label>
        </div>
        <AddButton
          prefixIcon={false}
          // ref={submitRef}
          onclkFn={() => {
            setStatus("Confirmation");
            setPosition(4);
          }}
          text={<span>View Profile</span>}
          className=" w-full justify-center h-[52px]
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer bg-[var(--primary-button-bg-color)]
    text-white
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--abha-method-card-title-fs)]
    font-[var(--abha-method-title-fw)]
    "
          type="button"
        />
      </div>
    </div>
  );
}

export default Popup;
